module.exports = __webpack_public_path__ + "faSawBottom.webp?afe360167b51d0c61d513defef6743c9";